import { render, staticRenderFns } from "./ArticleAttribute.vue?vue&type=template&id=b6f7681c&"
import script from "./ArticleAttribute.vue?vue&type=script&lang=js&"
export * from "./ArticleAttribute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports